/* global Stripe */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, formValueSelector, submit, Form, SubmissionError } from 'redux-form/immutable';
import FlatButton from 'material-ui/FlatButton';
// import Card from 'react-credit-card';
import {
  TextField,
} from 'redux-form-material-ui';

// import 'react-credit-card/source/card.css';
// import 'react-credit-card/source/card-types.css';

import ReduxDialog from '../Common/ReduxDialog';
import { required } from '../../utils/formvalidation';

import commonStyles from '../styles';
import styles from './styles';

import { showDialog, hideDialog, showError } from '../../actions/dialogs';

if (window.location.hostname === 'hub.staza.io') {
  Stripe.setPublishableKey('pk_live_1yeraU9HDVYQPInRRxRAFH1s');
} else {
  Stripe.setPublishableKey('pk_test_0U16R3nYiIlUXvGNDIPcJgFG');
}

class CreditCardCapture extends Component {
  static propTypes = {
    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func,
    onRequestClose: PropTypes.func,

    cvc: PropTypes.string,
    name: PropTypes.string,
    number: PropTypes.string,
    expiry: PropTypes.string,
  };

  state = {};

  componentWillMount() {
  }

  handleDiscard = () => {
    this.props.hideDialog('creditcard');
  };

  render() {
    const { cvc, name, number, expiry, handleSubmit } = this.props;

    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={this.handleDiscard}
      />,
      <FlatButton
        label="Save"
        type="button"
        primary
        onClick={() => this.props.submit('CreditCard')}
      />,
    ];

    return (
      <ReduxDialog
        title={'Payment Information'}
        actions={actions}
        name="creditcard"
        onRequestClose={this.handleDiscard}
        bodyStyle={styles.body}
      >
        <Form id="creditcard" role="form" name="CreditCard" onSubmit={handleSubmit}
              style={styles.row}>
          {/*<div style={styles.creditCard}>*/}
            {/*<Card*/}
              {/*cvc={cvc}*/}
              {/*name={name}*/}
              {/*number={number}*/}
              {/*expiry={expiry}*/}
              {/*focused={'name'}*/}
            {/*/>*/}
          {/*</div>*/}

          <div style={styles.creditCardProps}>
            <Field
              name="number"
              style={commonStyles.input}
              component={TextField}
              floatingLabelFixed
              floatingLabelText="Number"
              fullWidth
              validate={[required]}
            />
            <Field
              name="name"
              style={commonStyles.input}
              component={TextField}
              floatingLabelFixed
              floatingLabelText="Name"
              fullWidth
              validate={[required]}
            />
            <div style={styles.row}>
              <Field
                name="expiryMonth"
                style={commonStyles.input}
                component={TextField}
                floatingLabelFixed
                floatingLabelText="Expiry Month"
                fullWidth
                validate={[required]}
              />
              <Field
                name="expiryYear"
                style={commonStyles.input}
                component={TextField}
                floatingLabelFixed
                floatingLabelText="Expiry Year"
                fullWidth
                validate={[required]}
              />
              <Field
                name="cvc"
                style={commonStyles.input}
                component={TextField}
                floatingLabelFixed
                floatingLabelText="CVC"
                fullWidth
                validate={[required]}
              />
            </div>
          </div>
        </Form>
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'CreditCard',  // a unique identifier for this form
  onSubmit: (values) => {
    console.log('submit', values.toJS());
    const data = {
      number: values.get('number'),
      cvc: values.get('cvc'),
      exp_month: values.get('expiryMonth'),
      exp_year: values.get('expiryYear'),
    };

    return new Promise((resolve, reject) => {
      Stripe.createToken(data, (status, response) => {
        console.log('status', status);
        if (response.error) {
          console.error('error', response.error);
          reject(new SubmissionError(response.error.message));
        } else {
          // resolve(AccountsService.savePaymentSource(response.id));
          console.log('response', response);
          const token = response.id;
          resolve(token);
        }
      });
    });
  },
  onSubmitSuccess: (token, dispatch, props) => {
    props.onRequestClose({ token });
    props.hideDialog('creditcard');
  },
  onSubmitFail: (error, dispatch) => {
    dispatch(showError('Payment Error', error));
  },
})(CreditCardCapture);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
    submit,
  }, dispatch);
}

function mapStateToProps(state) {
  const selector = formValueSelector('CreditCard');
  const dialogs = state.get('dialogs').get('dialogs').toJS();

  return {
    dialogs,
    onRequestClose: dialogs.creditcard.context.onRequestClose,

    name: selector(state, 'name'),
    cvc: selector(state, 'cvc'),
    number: selector(state, 'number'),
    expiry: selector(state, 'expiry'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/CreditCardCapture/index.js